/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_DetailsInputs */

const en_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment details`)
};

const id_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail pembayaran`)
};

const ms_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butiran pembayaran`)
};

const ca_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalls del pagament`)
};

const cs_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platební údaje`)
};

const da_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betalingsoplysninger`)
};

const de_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungsdetails`)
};

const et_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makse üksikasjad`)
};

const es_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información del pago`)
};

const fr_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails de paiement`)
};

const hr_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podaci o plaćanju`)
};

const it_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli di pagamento`)
};

const lv_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksājuma informācija`)
};

const lt_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mokėjimo informacija`)
};

const hu_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizetési módok`)
};

const nl_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betalingsgegevens`)
};

const nb_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betalingsopplysninger`)
};

const pl_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szczegóły płatności`)
};

const pt_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados de pagamento`)
};

const ro_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalii de plată`)
};

const sk_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podrobnosti o platbe`)
};

const sl_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podatki o plačilu`)
};

const fi_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksutiedot`)
};

const sv_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betalningsinformation`)
};

const vi_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin thanh toán`)
};

const tr_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödeme detayları`)
};

const el_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λεπτομέρειες πληρωμής`)
};

const bg_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данни за плащане`)
};

const ru_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платежные реквизиты`)
};

const sr_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Детаљи плаћања`)
};

const uk_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Деталі оплати`)
};

const ka_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გადახდის დეტალები`)
};

const hi_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेमेंट डिटेल्स `)
};

const th_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายละเอียดการชำระเงิน`)
};

const ko_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제 세부 정보`)
};

const zh_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款详情`)
};

const zh_tw_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款細節`)
};

const ja_payment_details = /** @type {(inputs: Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お支払い方法`)
};

/**
* | output |
* | --- |
* | "Payment details" |
*
* @param {Payment_DetailsInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const payment_details = /** @type {((inputs?: Payment_DetailsInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_DetailsInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_payment_details(inputs)
	if (locale === "ms") return ms_payment_details(inputs)
	if (locale === "ca") return ca_payment_details(inputs)
	if (locale === "cs") return cs_payment_details(inputs)
	if (locale === "da") return da_payment_details(inputs)
	if (locale === "de") return de_payment_details(inputs)
	if (locale === "et") return et_payment_details(inputs)
	if (locale === "es") return es_payment_details(inputs)
	if (locale === "fr") return fr_payment_details(inputs)
	if (locale === "hr") return hr_payment_details(inputs)
	if (locale === "it") return it_payment_details(inputs)
	if (locale === "lv") return lv_payment_details(inputs)
	if (locale === "lt") return lt_payment_details(inputs)
	if (locale === "hu") return hu_payment_details(inputs)
	if (locale === "nl") return nl_payment_details(inputs)
	if (locale === "nb") return nb_payment_details(inputs)
	if (locale === "pl") return pl_payment_details(inputs)
	if (locale === "pt") return pt_payment_details(inputs)
	if (locale === "ro") return ro_payment_details(inputs)
	if (locale === "sk") return sk_payment_details(inputs)
	if (locale === "sl") return sl_payment_details(inputs)
	if (locale === "fi") return fi_payment_details(inputs)
	if (locale === "sv") return sv_payment_details(inputs)
	if (locale === "vi") return vi_payment_details(inputs)
	if (locale === "tr") return tr_payment_details(inputs)
	if (locale === "el") return el_payment_details(inputs)
	if (locale === "bg") return bg_payment_details(inputs)
	if (locale === "ru") return ru_payment_details(inputs)
	if (locale === "sr") return sr_payment_details(inputs)
	if (locale === "uk") return uk_payment_details(inputs)
	if (locale === "ka") return ka_payment_details(inputs)
	if (locale === "hi") return hi_payment_details(inputs)
	if (locale === "th") return th_payment_details(inputs)
	if (locale === "ko") return ko_payment_details(inputs)
	if (locale === "zh") return zh_payment_details(inputs)
	if (locale === "zh-tw") return zh_tw_payment_details(inputs)
	if (locale === "ja") return ja_payment_details(inputs)
	return en_payment_details(inputs)
});